var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg17 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "17")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M78.77,79c-2,2-4.61,2.62-5.84,1.39l-2.3-2.3,7.15-7.31,2.38,2.38C81.39,74.42,80.77,77,78.77,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M75.76,68.53,60.93,53.7A28.16,28.16,0,0,0,37.48,9.95c-15.56,0-28.4,12.61-28.17,28.17C9.55,54,22.1,66.5,37.48,66.28A28.65,28.65,0,0,0,53.81,61L68.62,75.84Zm-18.48-30A19.81,19.81,0,1,1,37.48,18.69,19.81,19.81,0,0,1,57.28,38.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.61,56.79A18.33,18.33,0,1,1,55.94,38.46,18.35,18.35,0,0,1,37.61,56.79Zm0-35.65A17.32,17.32,0,1,0,54.93,38.46,17.34,17.34,0,0,0,37.61,21.14Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg17, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/17.4eb031b9.svg";
export { ForwardRef as ReactComponent };